import { PayloadAction } from '@reduxjs/toolkit';
import { handleResponseError, handleResponseMessage } from 'app/rootSaga';
import { AxiosError } from 'axios';
import { Menu } from 'features/MenuList/models/menu';
import { CommonResponse } from 'models';
import { call, put, takeLatest } from 'redux-saga/effects';
import menuDetailService from './menuDetailService';
import { menuDetailActions } from './menuDetailSlice';

function* updateMenu(action: PayloadAction<Menu>) {
  try {
    const params = action.payload;
    const response: CommonResponse<null> = yield call(menuDetailService.patchMenu, params);
    yield put(menuDetailActions.patchMenuSuccess());
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    const axiosError = e as AxiosError<CommonResponse<null>>;
    const commonResponse = axiosError.response?.data;
    if (commonResponse) {
      yield put(menuDetailActions.patchMenuFailed());
    }
    yield handleResponseError(e as AxiosError);
  }
}

function* updateSubMenu(action: PayloadAction<Menu>) {
  try {
    const params = action.payload;
    const response: CommonResponse<null> = yield call(menuDetailService.patchSubMenu, params);
    yield put(menuDetailActions.patchSubMenuSuccess());
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    const axiosError = e as AxiosError<CommonResponse<null>>;
    const commonResponse = axiosError.response?.data;
    if (commonResponse) {
      yield put(menuDetailActions.patchSubMenuFailed());
    }
    yield handleResponseError(e as AxiosError);
  }
}

function* getMenu(action: PayloadAction<{ menu_id: number; expired_date: string }>) {
  try {
    const params = action.payload;
    const response: CommonResponse<Menu> = yield call(menuDetailService.getMenu, params);
    yield put(menuDetailActions.fetchMenuSuccess(response));
  } catch (e) {
    yield put(menuDetailActions.fetchMenuFailed());
    yield handleResponseError(e as AxiosError);
  }
}

export default function* menuDetailSaga() {
  yield takeLatest(menuDetailActions.patchMenu.type, updateMenu);
  yield takeLatest(menuDetailActions.patchSubMenu.type, updateSubMenu);
  yield takeLatest(menuDetailActions.fetchMenu.type, getMenu);
}
